<template>
  <w-icon-wrapper icon-name='work-application-reopen-icon'>
    <path
      id='Pfad_55754'
      d='M19,10.421a1,1,0,0,0-1,1V22H2V4H13.368a1,1,0,0,0,0-2H0V24H20V11.421A1,1,0,0,0,19,10.421Z'
      data-name='Pfad 55754'
      fill='currentColor'
    />
    <path
      id='Pfad_55755'
      d='M18,0a1,1,0,0,0,0,2h2.586L15.793,6.793a1,1,0,1,0,1.414,1.414L22,3.414V6a1,1,0,0,0,2,0V0Z'
      data-name='Pfad 55755'
      fill='currentColor'
    />
    <path
      id='Pfad_55756'
      d='M5,8h5a1,1,0,0,0,0-2H5A1,1,0,0,0,5,8Z'
      data-name='Pfad 55756'
      fill='currentColor'
    />
    <path
      id='Pfad_55757'
      d='M5,12h7a1,1,0,0,0,0-2H5a1,1,0,0,0,0,2Z'
      data-name='Pfad 55757'
      fill='currentColor'
    />
    <path
      id='Pfad_55758'
      d='M16,15a1,1,0,0,0-1-1H5a1,1,0,0,0,0,2H15A1,1,0,0,0,16,15Z'
      data-name='Pfad 55758'
      fill='currentColor'
    />
    <path
      id='Pfad_55759'
      d='M5,18a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z'
      data-name='Pfad 55759'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconApplicationReopen' };
</script>
